module.exports = __webpack_public_path__ + "img/play-1.6a15cb87.png";